import React from 'react';
import Link from '../../../../../elements/Link';
import Icon from '../../../../../elements/icons/Icon';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { isSessionSelectionControlsVisible } from '../isSessionSelectionControlsVisible';

function LeaveSession(props) {
    const { event, session, onClick } = props,
        i18n = useI18n();

    if (!isSessionSelectionControlsVisible(event, session)) return null;
    if (!session.is_selected) return null;

    return (
        <Link onClick={onClick}>
            <Icon
                src="/img/minus-circle-negative.png"
                style={{
                    marginBottom: 4,
                }}
            />
            <br />
            {i18n['label.deselect_session']}
        </Link>
    );
}

export default LeaveSession;
